// maxLengthで指定した文字数のstr + '...' で省略
// truncate("123456789", 5) => "12345..."
export const truncate = (str: string, maxLength: number): string => {
  return str.length <= maxLength ? str : str.substr(0, maxLength) + "...";
};
